module.exports = __webpack_public_path__ + "img/banner4.0e8e1054.jpg";